import { createReducer } from '@reduxjs/toolkit'
import { Actions_Settings } from './Actions'
import { IStateSettings } from './TReducer'

const initialState: IStateSettings = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerSettings = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_Settings.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_Settings.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_Settings.store.saveSettings, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerSettings
